import { useRef, useState, useEffect, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux"
import { set, useForm } from "react-hook-form";
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import { Box, Badge } from "@mui/material";
import Typography from '@mui/material/Typography';
// import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import { usePbiCreateSubscriptionsMutation, usePbiEditSubscriptionsMutation, usePbiGetSubscriptionsMutation } from '../features/auth/authApiSlice'
import { selectCurrentUser, selectSelectedReportDetails, selectPBIWorkspace, selectPBIReportList } from "../features/auth/authSlice"
import { selectReportId, selectSelectedSubscription, selectUserData, setUserSubscription, setSelectedFrequency, selectIsEditSubsription } from "../features/data/dataSlice"
import { setSelectedOffset, setSelectedweekdayOffset, setSelectedFileFormat, selectSelectedFrequency, selectSelectedOffset, selectSelectedweekdayOffset, selectSelectedTimeOffset, selectSelectedFileFormat, selectIsSubscriptionActive, selectSubscriptionReportId } from "../features/data/dataSlice"
import Spinner from './Spinner'
import DateFormatConfirmation from '../features/subscription/DateFormatConfimation'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 2,
  height: '95%',
  display: 'block',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    width: '0.4em'
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.5)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,.2)',
    outline: '1px solid slategrey'
  }
};

const schedules = [
  {
    value: 'days',
    label: 'Daily',
  },
  {
    value: 'weeks',
    label: 'Weekly',
  },
  {
    value: 'months',
    label: 'Monthly',
  }
];

const scheduleDay = [
  {
    value: 0,
    label: 'Monday'
  },
  {
    value: 1440,
    label: 'Tuesday'
  },
  {
    value: 2880,
    label: 'Wednesday'
  },
  {
    value: 4320,
    label: 'Thursday'
  },
  {
    value: 5760,
    label: 'Friday'
  },
  {
    value: 7200,
    label: 'Saturday'
  },
  {
    value: 8640,
    label: 'Sunday'
  }
];

const scheduleMonthDay = [
  {
    value: 0,
    label: '1'
  },
  {
    value: 1440,
    label: '2'
  },
  {
    value: 2880,
    label: '3'
  },
  {
    value: 4320,
    label: '4'
  },
  {
    value: 5760,
    label: '5'
  },
  {
    value: 7200,
    label: '6'
  },
  {
    value: 8640,
    label: '7'
  }, {
    value: 10080,
    label: '8'
  },
  {
    value: 11520,
    label: '9'
  },
  {
    value: 12960,
    label: '10'
  },
  {
    value: 14400,
    label: '11'
  },
  {
    value: 15840,
    label: '12'
  },
  {
    value: 17280,
    label: '13'
  },
  {
    value: 18720,
    label: '14'
  },
  {
    value: 20160,
    label: '15'
  },
  {
    value: 21600,
    label: '16'
  },
  {
    value: 23040,
    label: '17'
  },
  {
    value: 24480,
    label: '18'
  },
  {
    value: 25920,
    label: '19'
  },
  {
    value: 27360,
    label: '20'
  },
  {
    value: 28800,
    label: '21'
  }, {
    value: 30240,
    label: '22'
  },
  {
    value: 31680,
    label: '23'
  },
  {
    value: 33120,
    label: '24'
  },
  {
    value: 34560,
    label: '25'
  },
  {
    value: 36000,
    label: '26'
  },
  {
    value: 37440,
    label: '27'
  },
  {
    value: 38880,
    label: '28'
  },
  {
    value: 40320,
    label: '29'
  },
  {
    value: 41760,
    label: '30'
  },
  {
    value: 43200,
    label: '31'
  }
];

const documentstype = [
  {
    value: 'PDF',
    label: 'PDF',
  },
  {
    value: 'XLSX',
    label: 'Excel',
  },
  {
    value: 'TXT',
    label: 'Text',
  },
  {
    value: 'CSV',
    label: 'CSV',
  }
  
];

const documentstypePDF = [
  {
    value: 'PDF',
    label: 'PDF',
  }
];

const label = { inputProps: { 'aria-label': 'Switch demo' } };
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const AddSubscription = ({ openAddSubscription, handleAddSubscriptionClose }) => {
  const user = useSelector(selectCurrentUser)
  const reportEmbeddObj = useSelector(selectSelectedReportDetails)
  const SelectedSubscriptionProps = useSelector(selectSelectedSubscription)
  let setSubscriptionNameObject = {
    "reportName": reportEmbeddObj && reportEmbeddObj.name ? reportEmbeddObj.name : "",
    "subName": reportEmbeddObj && reportEmbeddObj.name ? reportEmbeddObj.name : "",
    "attechmentName": reportEmbeddObj && reportEmbeddObj.name ? reportEmbeddObj.name : "",
    "emailSubjectName": reportEmbeddObj && reportEmbeddObj.name ? reportEmbeddObj.name : "",
    "emailBody": "Hi, Please find attached herewith Energy Consumption Monitoring Report for your review & necessary action. Team-Energy Management System."
  }
  let editSubscriptiondata = SelectedSubscriptionProps && SelectedSubscriptionProps.actionOptions && SelectedSubscriptionProps.actionOptions.length ? JSON.parse(SelectedSubscriptionProps.actionOptions[0]) : {}
  let EditSubscriptionObj = {
    "reportName": SelectedSubscriptionProps && SelectedSubscriptionProps.name ? SelectedSubscriptionProps.name : "",
    "subName": SelectedSubscriptionProps && SelectedSubscriptionProps.name ? SelectedSubscriptionProps.name : "",
    "attechmentName": editSubscriptiondata && editSubscriptiondata.attachment ? editSubscriptiondata.attachment : "",
    "emailSubjectName": editSubscriptiondata && editSubscriptiondata.subject ? editSubscriptiondata.subject : "",
    "emailBody": editSubscriptiondata && editSubscriptiondata.body ? editSubscriptiondata.body : ""
  }

  const pbiWorkSpaceDetails = useSelector(selectPBIWorkspace)
  const reportid = useSelector(selectReportId)
  const subscriptionreportid = useSelector(selectSubscriptionReportId)
  const selectedfrequency = useSelector(selectSelectedFrequency)
  const selectedoffset = useSelector(selectSelectedOffset)
  const selectedWeekdayoffset = useSelector(selectSelectedweekdayOffset)
  const selectedtimeoffset = useSelector(selectSelectedTimeOffset)
  const selectedFileFormatVal = useSelector(selectSelectedFileFormat)
  const selectedIsSubsActiveVal = useSelector(selectIsSubscriptionActive)
  const isEditMode = useSelector(selectIsEditSubsription)
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [pbiAddUpdateSubscription, { isPbiAddUpdateLoading }] = usePbiCreateSubscriptionsMutation()
  const [pbiEditSubscription, { isPbiEditLoading }] = usePbiEditSubscriptionsMutation()
  const [pbiSubscriptionList, { ispbiSubscriptionListLoading }] = usePbiGetSubscriptionsMutation()
  const [subscriptionName, setSubscriptionName] = useState(isEditMode ? EditSubscriptionObj : setSubscriptionNameObject);
  const [emailDetail, setEmailDetail] = useState("");
  const [frequencyValue, setFrequencyValue] = useState(selectedfrequency);
  const [freqOffset, setFreqOffset] = useState(0);
  const [frequencyweeksday, setFrequencyweeksday] = useState(0);
  const [frequencyMonthsday, setFrequencyMonthsday] = useState(0);
  const [specificTime, setSpecificTime] = useState("01:00");
  const [documentType, setDocumentType] = useState(selectedFileFormatVal);
  const [emails, setEmails] = useState([]);
  const [ccemails, setCCEmails] = useState([]);
  const [bccemails, setBCCEmails] = useState([]);
  const [focused, setFocused] = useState(false);
  const [spinnerLoad, setSpinnerLoad] = useState(false);
  const [isEmailOverLength, setIsEmailOverLength] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [optionSelectd, setOptionSelectd] = useState({ dateFormat: false });
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState('');
  const dispatch = useDispatch()
  const [errMsg, setErrMsg] = useState('')
  const [subsError, setSubsError] = useState('')
  const [emailError, setEmailError] = useState(true);

  const userdata = useSelector(selectUserData)

  const reportList = useSelector(selectPBIReportList);

  const covertproperEmailVal = (emailval) => {
    const emailsplit = emailval.split(":");
    return emailsplit[1]
  }

  // const handleSubscriptionProps = () => {
  //   if (SelectedSubscriptionProps) {
  //     const emailprops = SelectedSubscriptionProps.actions && SelectedSubscriptionProps.actions.length ? SelectedSubscriptionProps.actions[0].trim() : ""
  //     const emailpropsarray = emailprops.split(" ");
  //     let emailvalue = "";
  //     let ccvalue = "";
  //     let bccvalue = "";
  //     emailpropsarray.map((item) => {
  //       if (item.toLocaleLowerCase().includes('mailto:')) {
  //         emailvalue = item;
  //       }
  //       if (item.toLocaleLowerCase().includes('cc:')) {
  //         if (item.toLocaleLowerCase().includes('bcc:')) {
  //           bccvalue = item;
  //         } else {
  //           ccvalue = item;
  //         }
  //       }
  //     });

  //     const multiEmail = emailvalue ? covertproperEmailVal(emailvalue).split(";") : [];
  //     const multiCCEmail = ccvalue ? covertproperEmailVal(ccvalue).split(";") : [];
  //     const multiBCCEmail = bccvalue ? covertproperEmailVal(bccvalue).split(";") : [];

  //     const offsetTimeHourStr = `${Math.floor(selectedtimeoffset / 60)}`.padStart(2, 0);
  //     const offsetTimeMinuteStr = `${selectedtimeoffset % 60}`.padStart(2, 0);
      
  //     setEmailDetail(emailprops)
  //     setEmails(multiEmail)
  //     setCCEmails(multiCCEmail)
  //     setBCCEmails(multiBCCEmail)
  //     setFrequencyValue(selectedfrequency)
  //     setSpecificTime(`${offsetTimeHourStr}:${offsetTimeMinuteStr}`)
  //     setDocumentType(selectedFileFormatVal)

  //     if (SelectedSubscriptionProps.offset && selectedfrequency == "weeks") {
  //       setFrequencyweeksday(selectedoffset)
  //     }
  //     if (SelectedSubscriptionProps.offset && selectedfrequency == "months") {
  //       setFrequencyMonthsday(selectedoffset)
  //     }
  //   }
  // }

  const methods = useForm();

  // useEffect(() => {
  //   handleSubscriptionProps();
  // }, [SelectedSubscriptionProps])

  useEffect(() => {
    if (isEditMode) {
      setSubscriptionName(EditSubscriptionObj)
    } else {
      setSubscriptionName(setSubscriptionNameObject)
    }
  }, [isEditMode, handleAddSubscriptionClose])

  const handleEditSUbscription = () => {
    try {
      let subscriptionObj = SelectedSubscriptionProps && SelectedSubscriptionProps.actions &&
        SelectedSubscriptionProps.actions.length &&
        JSON.parse(SelectedSubscriptionProps.actions[0].replace("mailto:", ""));
      const offsetTimeHourStr = `${Math.floor(selectedtimeoffset / 60)}`.padStart(2, 0);
      const offsetTimeMinuteStr = `${selectedtimeoffset % 60}`.padStart(2, 0);
      setEmails(subscriptionObj.receiver)
      setCCEmails(subscriptionObj.cc === null ? [] : subscriptionObj.cc)
      setBCCEmails(subscriptionObj.bcc === null ? [] : subscriptionObj.bcc)
      setFrequencyValue(selectedfrequency)
      setSpecificTime(`${offsetTimeHourStr}:${offsetTimeMinuteStr}`)
      setDocumentType(selectedFileFormatVal)
      if (SelectedSubscriptionProps && SelectedSubscriptionProps.offset && selectedfrequency == "weeks") {
        setFrequencyweeksday(selectedWeekdayoffset)
      }
      if (SelectedSubscriptionProps && SelectedSubscriptionProps.offset && selectedfrequency == "months") {
        setFrequencyMonthsday(selectedoffset)
      }
    } catch (e) {
      console.log('err-', e)
      setEmails([])
      setCCEmails([])
      setBCCEmails([])
    }
  }
  useEffect(() => {
    if (isEditMode) {
      handleEditSUbscription();
    }
  }, [isEditMode])

  useEffect(() => {
    try {
      const offsetTimeHourStr = `${Math.floor(selectedtimeoffset / 60)}`.padStart(2, 0);
      const offsetTimeMinuteStr = `${selectedtimeoffset % 60}`.padStart(2, 0);
      setFrequencyValue(selectedfrequency)
      setSpecificTime(`${offsetTimeHourStr}:${offsetTimeMinuteStr}`)
      setDocumentType(selectedFileFormatVal)

      if (SelectedSubscriptionProps && SelectedSubscriptionProps.offset && selectedfrequency == "weeks") {
        setFrequencyweeksday(selectedWeekdayoffset)
      }
      if (SelectedSubscriptionProps && SelectedSubscriptionProps.offset && selectedfrequency == "months") {
        setFrequencyMonthsday(selectedoffset)
      }
    } catch (e) {
      console.log('err-', e)
    }

  }, [selectedfrequency, selectedWeekdayoffset, selectedoffset, selectedtimeoffset, selectedFileFormatVal])


  useEffect(() => {
    // handleSubscriptionProps();
    // methods.reset({
    //   subscriptionname: subscriptionName.subName,
    //   emailSubjectName: subscriptionName.emailSubjectName,
    //   attachmentName: subscriptionName.attechmentName,
    //   emailBody: subscriptionName.emailBody,
    //   emails: emails,
    //   // email: emailDetail,
    //   filledselectfrequency: frequencyValue,
    //   frequencyweeksday: frequencyweeksday,
    //   frequencymonthdays: frequencyMonthsday,
    //   specifictimevalue: specificTime,
    //   filledselectdoctype: documentType
    // })
  }, [subscriptionName])
  //methods.reset,  subscriptionName, emails, frequencyValue, frequencyweeksday, frequencyMonthsday, specificTime, documentType

  // useEffect(() => {
  //   setSubscriptionNameObject = {
  //     ...subscriptionName,
  //     subName: reportEmbeddObj.name ? reportEmbeddObj.name : "",
  //     attechmentName: reportEmbeddObj.name ? reportEmbeddObj.name : "",
  //     emailSubjectName: reportEmbeddObj.name ? reportEmbeddObj.name : "",
  //     emailBody: "Hi, Please find attached herewith Energy Consumption Monitoring Report for your review & necessary action. Team-Energy Management System."
  //   }
  //   setSubscriptionName(setSubscriptionNameObject)

  // }, [handleAddSubscriptionClose])

  const CalculateOffsetVal = (value) => {
    const offsetval = 0;
    const timesplit = value.split(':')
    const hourval = timesplit[0] * 60;
    const hourvaltominute = parseInt(hourval) + parseInt(timesplit[1]);
    if (selectedfrequency == "days") {
      return hourvaltominute;
    }
    if (selectedfrequency == "weeks") {
      const freqOffsetvalue = SelectedSubscriptionProps ? freqOffset : frequencyweeksday;
      const weeksoffset = freqOffsetvalue + hourvaltominute;
      return weeksoffset;
    }
    if (selectedfrequency == "months") {
      const freqOffsetvalue = SelectedSubscriptionProps ? freqOffset : frequencyMonthsday;
      const monthsoffset = freqOffsetvalue + hourvaltominute;
      return monthsoffset;
    }
  }

  const handleGetAllSubscripion = async () => {
    try {
      setSpinnerLoad(true)
      setErrMsg('');
      const logindetails = { "loginId": userdata.userName }
      const getSubscriptionList = await pbiSubscriptionList(logindetails).unwrap();
      if (getSubscriptionList && getSubscriptionList.subscriptions) {
        dispatch(setUserSubscription(getSubscriptionList.subscriptions))
        setSpinnerLoad(false)
      } else {
        dispatch(setUserSubscription([]))
        setSpinnerLoad(false)
      }
    } catch (err) {
      if (!err?.originalStatus) {
        // isLoading: true until timeout occurs
        setErrMsg('No Server Response');
      } else if (err.originalStatus === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.originalStatus === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      // errRef.current.focus();
      setSpinnerLoad(false)
    }
  }

  const handleReportsFilters = data => {
    const filterarray = [];
    data && data.map(obj => {
      const filtername = obj.filters.length ? obj.filters[0].target.column : "";
      const filtervalue = obj.filters.length ? obj.filters[0].values : [];
      if (filtervalue && filtervalue.length) {
        filtervalue.map(value => filterarray.push({ "name": filtername, "value": String(value) }));
      }
    })
    return filterarray;
  }

  const handleAddUpdateSubscription = async (data) => {
    // let mailtoaddr = `mailto:${data.email}`;
    try {
      setSpinnerLoad(true)
      const filterReportDataLS = JSON.parse(localStorage.getItem('filterdata'));
      const filterReportData = filterReportDataLS && filterReportDataLS.length ? handleReportsFilters(filterReportDataLS) : [];
      const reportIDtoSubscribe = subscriptionreportid ? subscriptionreportid : reportid;
      const paginatedvalue = subscriptionreportid || (SelectedSubscriptionProps && SelectedSubscriptionProps.paginated == "true") ? true : false;
      // const mailtoaddr = `mailto:${emails.join(';')} ${ccemails.length ? `cc:${ccemails.join(';')}` : ''} ${bccemails.length ? `bcc:${bccemails.join(';')}` : ''}`;
      const offsetvalue = CalculateOffsetVal(specificTime); //data.specifictimevalue
      const subscriptionData = {
        "nextExecutionDate": null,
        "offset": offsetvalue,
        "groupId": pbiWorkSpaceDetails,
        "reportId": SelectedSubscriptionProps && SelectedSubscriptionProps.reportId ? SelectedSubscriptionProps.reportId : reportIDtoSubscribe,
        "usersWithEditPermission": user,
        "usersWithViewPermission": user,
        "id": SelectedSubscriptionProps && SelectedSubscriptionProps.id ? SelectedSubscriptionProps.id : 0,
        "fileFormat": selectedFileFormatVal,
        //"actions": mailtoaddr,
        "reportName": subscriptionName.reportName,
        "subscriptionName": subscriptionName.subName, //data.subscriptionname,
        "emailSubject": subscriptionName.emailSubjectName, //data.emailSubjectName,
        "attachmentName": subscriptionName.attechmentName,//data.attachmentName,
        "actionOptions": "",
        "offsetUnit": "minutes",
        "frequencyUnit": frequencyValue, //data.filledselectfrequency,
        "frequency": 1,
        "paginated": paginatedvalue,
        "filters": SelectedSubscriptionProps ? [] : filterReportData,
        "locale": userdata && userdata.language && userdata.language.defaultCulture ? userdata.language.defaultCulture : "en-US",
        "body": subscriptionName.emailBody,//data.emailBody,
        "bcc": bccemails,
        "cc": ccemails,
        "receiver": emails,
      }
      if (SelectedSubscriptionProps && SelectedSubscriptionProps.id) {
        const getEditResponse = await pbiEditSubscription(subscriptionData);
        if (getEditResponse && getEditResponse.data && getEditResponse.data.code === 200) {
          setSpinnerLoad(false)
          handleAddSubscriptionClose();
          handleGetAllSubscripion();
          setOpenSnackbar(true);
          setTimeout(() => {
            setOpenSnackbar(false);
          }, 2000);
        } else if (getEditResponse && getEditResponse.error && getEditResponse.error.status === 400) {
          setSubsError(getEditResponse.error.data.message);
          setSpinnerLoad(false);
        }
        setSpinnerLoad(false)
      } else {
        const getAddResponse = await pbiAddUpdateSubscription(subscriptionData);
        if (getAddResponse && getAddResponse.data && getAddResponse.data.code === 200) {
          setSpinnerLoad(false)
          handleAddSubscriptionClose();
          setOpenSnackbar(true);
          setTimeout(() => {
            setOpenSnackbar(false);
          }, 2000);
        } else if (getAddResponse && getAddResponse.error && getAddResponse.error.status === 400) {
          setSubsError(getAddResponse.error.data.message);
          setSpinnerLoad(false);
        }
        setSpinnerLoad(false);
      }
    } catch (err) {
      console.log('err--', err)
      setSpinnerLoad(false)
      if (err && err.status === 400) {
        setSubsError(err.data.message);
        setSpinnerLoad(false);
      }
      if (!err?.originalStatus) {
        console.log(err)
      }
    }
  }

  const onSubmitform = (data) => {
    handleAddUpdateSubscription(data);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const handleFrequencySelect = (optionvalue) => {
    dispatch(setSelectedFrequency(optionvalue))
    //setFrequencyValue(optionvalue)
  }

  const handleFrequencyWeekDaySelect = (optionvalue) => {
    // dispatch(setSelectedOffset(optionvalue))
    dispatch(setSelectedweekdayOffset(optionvalue))
    setFreqOffset(optionvalue)
    setFrequencyweeksday(optionvalue)
    console.log(`This: ${frequencyweeksday}`);
  }

  const handleFrequencyMonthDaySelect = (optionvalue) => {
    setFreqOffset(optionvalue)
    dispatch(setSelectedOffset(optionvalue))
    setFrequencyMonthsday(optionvalue)
  }

  const handleFileFormatSelect = (optionvalue) => {
    dispatch(setSelectedFileFormat(optionvalue))
    // setDocumentType(optionvalue)
  }

  const onBlurRME = () => {
    // let combineEmailLength = emails.join().length + ccemails.join().length + bccemails.join().length;
    let combineEmails = [...emails, ...ccemails, ...bccemails];
    let combineEmailLength = combineEmails.join().length;
    if (combineEmailLength > 2048) {
      setIsEmailOverLength(true);
    } else {
      setIsEmailOverLength(false);
    }
  }
  const handleMenuopenclick = (event) => {
    setAnchorEl(event.currentTarget);
  }
  // const handleMenuitemclick = (value) => {
  //   const updatedoption = { ...optionSelectd, [value]: true }
  //   setOptionSelectd(updatedoption);
  //   setSubscriptionName((prevName) => ({
  //     ...prevName, emailSubjectName: prevName.emailSubjectName + '<' + value + '>',
  //     attechmentName: prevName.attechmentName + '<' + value + '>'
  //   }));
  //   setAnchorEl(null);
  // }
  const handleDateFormat = () => {
    setOpenDialog(true);
    setSelectedFormat('');
  }
  const confirmDateFormat = () => {
    const updatedoption = { dateFormat: true }
    setOptionSelectd(updatedoption);
    setSubscriptionName((prevName) => ({
      ...prevName, emailSubjectName: `${prevName.emailSubjectName} <dateformat:${selectedFormat}>`,
      attechmentName: `${prevName.attechmentName} <dateformat:${selectedFormat}>`
    }));
    handleCloseDialog();
    setAnchorEl(null);
  }
  useEffect(() => {
    if (!openAddSubscription) {
      setOptionSelectd({ dateFormat: false });
    }
  }, [openAddSubscription])

  const handleClosemenu = () => {
    setAnchorEl(null);
  }
  const handleCloseclick = () => {
    handleAddSubscriptionClose()
    setSubsError('')
    setErrMsg('')
    setOptionSelectd({ dateFormat: false });
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  }
  const regex = /[<>{}\[\]]/;

  const regexCheck = /[{}\[\]]/;

  const validateInput = (value) => {
    if (value && !regex.test(value)) { 
      setErrMsg("");
      return value;
    } else {
      setErrMsg("Invalid User input");
      return value;
    }
  }

  const validateInputs = (value) => {
    if (value && !regexCheck.test(value)) { 
      setErrMsg("");
      return value;
    } else {
      setErrMsg("Invalid User input");
      return value;
    }
  }

  useEffect(() => {
    let currVal = subscriptionName.emailSubjectName;
    setOptionSelectd({
      // date: currVal.includes('<date>'),
      dateFormat: currVal.includes(`<dateformat:${selectedFormat}>`),
      // time: currVal.includes('<time>'),
      // sec: currVal.includes('<sec>'),
      // millisec: currVal.includes('<millisec>')
    });
  }, [subscriptionName, subscriptionName.emailSubjectName, selectedFormat])
  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openAddSubscription}
        onClose={handleAddSubscriptionClose}
        closeAfterTransition
      // BackdropComponent={Backdrop}
      // BackdropProps={{
      //   timeout: 500,
      // }}
      >
        <Fade in={openAddSubscription}>
          <Box sx={style}>
            <form onSubmit={methods.handleSubmit((d) => onSubmitform(d))}>
              <Typography id="transition-modal-title" variant="h3" component="h2">
                Subscribe to email
              </Typography>
              <div className="divdivider">
                {/* {reportEmbeddObj && reportEmbeddObj.name && ( */}
                <Typography variant="h6" component="h6">
                  {isEditMode ? SelectedSubscriptionProps.name : reportEmbeddObj.name}
                </Typography>
              </div>
              <div className="switchdiv">
                {isEmailOverLength && (<Alert severity="error">Exceeded the maximum number of emails combine of TO, CC and BCC</Alert>)}
                {/* <Stack direction="row" spacing={1} alignItems="center"> */}
                {/* <Typography>Off</Typography>
                  <Switch checked={selectedIsSubsActiveVal} disabled color="secondary" /> 
                  <Typography>On</Typography> */}
                {isEditMode && <div>
                  {selectedIsSubsActiveVal ?
                    <div className="subscriptionStatus">
                      <Badge color='success' variant="dot" />
                      <span className="substatusTxt">Active</span>
                    </div> :
                    <div className="subscriptionStatus inactive">
                      <Badge color='#A9A9A9' variant="dot" />
                      <span className="substatusTxt">Inactive</span>
                    </div>
                  }
                </div>
                }
              </div>

              <TextField fullWidth name="subscriptionname"
                id="subscriptionname"
                label="Subscription Name*"
                variant="filled"
                value={subscriptionName.subName}
                onChange={(event) => setSubscriptionName({ ...subscriptionName, subName: validateInput(event.target.value) })}
                className="subscriptionformfeild"
              />
              <Box>
                {methods.formState?.errors?.subscriptionname?.message && (
                  <span className="error-message">{methods.formState.errors.subscriptionname.message}</span>
                )}
              </Box>

              <TextField fullWidth name="emailSubjectName"
                id="emailSubjectName"
                label="Email Subject"
                variant="filled"
                value={subscriptionName.emailSubjectName}
                onChange={(event) => setSubscriptionName({ ...subscriptionName, emailSubjectName: validateInputs(event.target.value) })}
                className="subscriptionformfeild"
                multiline
                InputProps={{
                  endAdornment: (
                    <><IconButton aria-label="Example" onClick={handleMenuopenclick}>
                      <MoreVertIcon />
                    </IconButton>
                      <Menu id="simple-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClosemenu}
                      >
                        {/* <MenuItem onClick={() => handleMenuitemclick('date')} disabled={optionSelectd.date}>date</MenuItem> */}
                        <MenuItem onClick={() => handleDateFormat('dateFormat')} disabled={optionSelectd.dateFormat}>dateTimeFormat</MenuItem>
                        {/* <MenuItem onClick={() => handleMenuitemclick('time')} disabled={optionSelectd.time}>time</MenuItem> */}
                        {/* <MenuItem onClick={() => handleMenuitemclick('sec')} disabled={optionSelectd.sec}>sec</MenuItem> */}
                        {/* <MenuItem onClick={() => handleMenuitemclick('millisec')} disabled={optionSelectd.millisec}>millisec</MenuItem> */}
                      </Menu></>
                  )
                }
                }
              />
              <Box>
                {methods.formState?.errors?.filledselectfrequency?.message && (
                  <span className="error-message">{methods.formState.errors.filledselectfrequency.message}</span>
                )}
              </Box>
              <TextField fullWidth name="subscriptionname"
                id="attachmentName"
                label="Attachment Name"
                variant="filled"
                multiline
                value={subscriptionName.attechmentName}
                onChange={(event) => setSubscriptionName({ ...subscriptionName, attechmentName: validateInputs(event.target.value) })}
                className="subscriptionformfeild"

              />
              {/* </Stack> */}
              <ReactMultiEmail fullWidth
                placeholder='To'
                id="emails"
                emails={emails}
                onChange={(_emails) => { setEmails(_emails) }}
                autoFocus={true}
                onFocus={() => setFocused(true)}
                onBlur={() => { setFocused(false); onBlurRME() }}
                getLabel={(email, index, removeEmail) => {
                  return (
                    <div data-tag key={index}>
                      <div data-tag-item>{email}</div>
                      <span data-tag-handle onClick={() => removeEmail(index)}>
                        ×
                      </span>
                    </div>
                  );
                }}
                //className="MuiInputBase-input MuiFilledInput-input css-10botns-MuiInputBase-input-MuiFilledInput-input"
                className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root subscriptionformfeild css-wb57ya-MuiFormControl-root-MuiTextField-root"
              />
              <ReactMultiEmail fullWidth
                placeholder='Cc'
                id="ccemails"
                variant="filled"
                emails={ccemails}
                onChange={(_emails) => { setCCEmails(_emails) }}
                autoFocus={true}
                onFocus={() => setFocused(true)}
                onBlur={() => { setFocused(false); onBlurRME() }}
                getLabel={(email, index, removeEmail) => {
                  return (
                    <div data-tag key={index}>
                      <div data-tag-item>{email}</div>
                      <span data-tag-handle onClick={() => removeEmail(index)}>
                        ×
                      </span>
                    </div>
                  );
                }}
                //className="MuiInputBase-input MuiFilledInput-input css-10botns-MuiInputBase-input-MuiFilledInput-input"
                className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root subscriptionformfeild css-wb57ya-MuiFormControl-root-MuiTextField-root"
              />
              <ReactMultiEmail fullWidth
                placeholder='Bcc'
                id="bccemails"
                variant="filled"
                emails={bccemails}
                onChange={(_emails) => { setBCCEmails(_emails) }}
                autoFocus={true}
                onFocus={() => setFocused(true)}
                onBlur={() => { setFocused(false); onBlurRME() }}
                getLabel={(email, index, removeEmail) => {
                  return (
                    <div data-tag key={index}>
                      <div data-tag-item>{email}</div>
                      <span data-tag-handle onClick={() => removeEmail(index)}>
                        ×
                      </span>
                    </div>
                  );
                }}
                //className="MuiInputBase-input MuiFilledInput-input css-10botns-MuiInputBase-input-MuiFilledInput-input"
                className="MuiFormControl-root MuiFormControl-fullWidth MuiTextField-root subscriptionformfeild css-wb57ya-MuiFormControl-root-MuiTextField-root"
              />
              <TextField fullWidth name="subscriptionname"
                id="EmailBody"
                label="Email Body"
                variant="filled"
                multiline
                // maxRows={4}
                value={subscriptionName.emailBody}
                onChange={(event) => setSubscriptionName({ ...subscriptionName, emailBody: validateInput(event.target.value) })}
                className="subscriptionformfeild"
              />
              {/* <TextField fullWidth name="email"
                className="subscriptionformfeild"
                id="email"
                defaultValue={emailDetail}
                label="Email*"
                variant="filled"
                {...methods.register("email", {
                  required: "Email is required",
                  validate: {
                    maxLength: (v) =>
                      v.length <= 50 || "The email should have at most 50 characters",
                    matchPattern: (v) =>
                      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                      "Email address must be a valid address",
                  },
                })}
              /> */}
              <Box>
                {methods.formState?.errors?.email?.message && (
                  <span className="error-message">{methods.formState.errors.email.message}</span>
                )}
              </Box>
              <Stack direction="row" spacing={2}>
                <TextField
                  id="filledselectfrequency"
                  name="filledselectfrequency"
                  select
                  label="Select Frequency"
                  helperText="Please Select Frequency"
                  variant="filled"
                  value={frequencyValue}
                  fullWidth
                  className="subscriptionformfeild schedulefld"
                  // {...methods.register("filledselectfrequency", {
                  //   required: "Required",
                  // })}
                  >
                  {schedules.map((option) => (
                    <MenuItem key={option.value} onClick={() => handleFrequencySelect(option.value)} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <Box>
                  {methods.formState?.errors?.filledselectfrequency?.message && (
                    <span className="error-message">{methods.formState.errors.filledselectfrequency.message}</span>
                  )}
                </Box>
                {selectedfrequency == "weeks" && (
                  <TextField
                    id="frequencyweeksday"
                    select
                    label="Select Day"
                    helperText="Please Select Day"
                    value={frequencyweeksday}
                    variant="filled"
                    fullWidth
                    className="subscriptionformfeild offsettimefd"
                    {...methods.register("frequencyweeksday", {
                      required: "Required",
                    })}
                  >
                    {scheduleDay.map((option) => (
                      <MenuItem key={option.value} onClick={() => handleFrequencyWeekDaySelect(option.value)} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                {selectedfrequency == "months" && (
                  <TextField
                    id="frequencymonthdays"
                    select
                    label="Select Day of Month"
                    helperText="Please Select Day of Month"
                    value={frequencyMonthsday}
                    variant="filled"
                    fullWidth
                    className="subscriptionformfeild offsettimefd"
                    {...methods.register("frequencymonthdays", {
                      required: "Required",
                    })}
                  >
                    {scheduleMonthDay.map((option) => (
                      <MenuItem key={option.value} onClick={() => handleFrequencyMonthDaySelect(option.value)} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                <TextField fullWidth
                  id="specifictimevalue"
                  className="subscriptionformfeild"
                  type="time"
                  label="Time (UTC)*"
                  variant="filled"
                  value={specificTime}
                  required
                  onChange={(event) => setSpecificTime(event.target.value)}
                  // {...methods.register("specifictimevalue", {
                  //   required: "Required",
                  // })}
                />
              </Stack>
              {!isEditMode && (
                <>
                  {subscriptionreportid && subscriptionreportid != reportid && (
                    <TextField
                      id="filledselectdoctype"
                      select
                      label="Select DOC type"
                      // defaultValue={documentType}
                      value={selectedFileFormatVal}
                      helperText="Please select your document type"
                      variant="filled"
                      fullWidth
                      className="subscriptionformfeild"
                      {...methods.register("filledselectdoctype", {
                        required: "Required",
                      })}
                    >
                      {documentstype.map((option) => (
                        <MenuItem key={option.value} onClick={() => handleFileFormatSelect(option.value)} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                  {!subscriptionreportid && (
                    <TextField
                      id="filledselectdoctype"
                      select
                      label="Select DOC type"
                      value={selectedFileFormatVal} //documentType
                      helperText="Please select your document type"
                      variant="filled"
                      fullWidth
                      className="subscriptionformfeild"
                      {...methods.register("filledselectdoctype", {
                        required: "Required",
                      })}>
                      {documentstypePDF.map((option) => (
                        <MenuItem key={option.value} onClick={() => handleFileFormatSelect(option.value)} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </>
              )}
              {isEditMode && (
                <>
                  {SelectedSubscriptionProps && SelectedSubscriptionProps.paginated == "true" && (
                    <TextField
                      id="filledselectdoctype"
                      select
                      label="Select DOC type"
                      value={selectedFileFormatVal}
                      helperText="Please select your document type"
                      variant="filled"
                      fullWidth
                      className="subscriptionformfeild"
                      {...methods.register("filledselectdoctype", {
                        required: "Required",
                      })}
                    >
                      {documentstype.map((option) => (
                        <MenuItem key={option.value} onClick={() => handleFileFormatSelect(option.value)} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                  {SelectedSubscriptionProps && SelectedSubscriptionProps.paginated == "false" && (
                    <TextField
                      id="filledselectdoctype"
                      select
                      label="Select DOC type"
                      value={selectedFileFormatVal}
                      helperText="Please select your document type"
                      variant="filled"
                      fullWidth
                      className="subscriptionformfeild"
                      {...methods.register("filledselectdoctype", {
                        required: "Required",
                      })}>
                      {documentstypePDF.map((option) => (
                        <MenuItem key={option.value} onClick={() => handleFileFormatSelect(option.value)} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </>
              )}
              {errMsg && (<span className="error-message">{errMsg}</span>)}
              {subsError && (<span className="error-message">{subsError}</span>)}
              <Stack className="divlogoutbtn" direction="row" spacing={2} sx={{ pb: "16px" }}>
                <Button type="submit" variant="contained" disabled={emails.length === 0 || isEmailOverLength || errMsg !== ''} color="primary" >Subscribe</Button>
                <Button variant="outlined" color="primary" onClick={() => handleCloseclick()} >Cancel</Button>
              </Stack>
            </form>
          </Box>
        </Fade>
      </Modal>
      <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={handleCloseAlert}>
        <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
          Your preferences saved succussfully
        </Alert>
      </Snackbar>
      {spinnerLoad && (<Spinner />)}
      {openDialog && <DateFormatConfirmation open={openDialog} selectedFormat={selectedFormat}
        setSelectedFormat={setSelectedFormat} close={handleCloseDialog}
        confirmDateFormat={confirmDateFormat} />}
    </>
  );
};

export default AddSubscription;
